export default __webpack_public_path__ + "static/img42h-62faa810828cc20bd70441c4963114c7.jpg";